import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes } from 'prop-types';
import { Button, ListGroup } from 'react-bootstrap';
import { SCHOOL_ROLE } from 'containers/User/constants.js';
import { useApi2call } from 'containers/Api2/index.js';
import DeleteButton from 'components/interaction/DeleteButton/index.jsx';
import SelectUsers from 'components/interaction/SelectUsers/index.jsx';
import UserAvatar from 'components/user/UserAvatar/index.jsx';
import messages from './messages.js';
import schoolRoleParser from '../Users/SchoolRole/schoolRoleParser.js';

function AccountRoles(props) {
  const { account } = props;
  const { schoolRoles, id, name, iban, currency } = account;
  const [show, setShow] = useState(false);
  const api2call = useApi2call();

  const selectOptions = {
    roles: [
      { id: SCHOOL_ROLE, name: 'schoolroles' },
    ],
    fetchOptions: {
      url: 'sa/schoolroles',
      version: 2,
      parser: schoolRoleParser,
    },
  };

  function handleChange(list) {
    const body = { name, iban, currency, schoolRoles: list.map((o) => o.id) };
    return api2call({
      method: 'PUT',
      url: `sa/bankaccounts/${id}`,
      version: 2,
      body,
    });
  }

  function handleDelete(removeId) {
    const list = schoolRoles.filter((o) => o.id !== removeId);
    handleChange(list);
  }

  async function handleAdd(list) {
    await handleChange(list);
    setShow(false);
  }

  return (
    <>
      <div className="fw-semibold">
        <FormattedMessage {...messages.whosAllowed} />
      </div>
      <div className="mb-3">
        <FormattedMessage {...messages.alwaysAllowed} />
      </div>
      {schoolRoles?.length > 0 && (
        <ListGroup className="mb-3">
          {schoolRoles.map((role) => (
            <ListGroup.Item key={role.id} className="px-0 d-flex">
              <UserAvatar user={role} className="flex-grow-1" />
              <DeleteButton variant="link" className="py-0" confirmText={{ ...messages.confirmRemoveRole, values: role }} onClick={() => handleDelete(role.id)} />
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
      <div>
        <Button variant="light" onClick={() => setShow(true)}>
          Rollen toevoegen
        </Button>
      </div>
      <SelectUsers
        {...selectOptions}
        show={show}
        value={schoolRoles}
        onChange={handleAdd}
        onHide={() => setShow(false)}
        prompt={messages.selectGroups}
        clientSearch
      />
    </>
  );
}

AccountRoles.propTypes = {
  account: PropTypes.object,
};

export default AccountRoles;
